// import React, { useState, useRef } from 'react';
// import Form from 'react-bootstrap/Form';
// import InputGroup from 'react-bootstrap/InputGroup';
// import Button from 'react-bootstrap/Button';
// import emailjs from 'emailjs-com';
// import ReCAPTCHA from "react-google-recaptcha";

// export const Contact = () => {
//   const [formData, setFormData] = useState({
//     first_name: '',
//     email_id: '',
//     message: '',
//   });

//   const [recaptchaValue, setRecaptchaValue] = useState(null);
//   const [validated, setValidated] = useState(false);
//   const [successMessage, setSuccessMessage] = useState('');
//   const recaptchaRef = useRef(null);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       [name]: value,
//     }));
//   };

//   const handleRecaptchaChange = (value) => {
//     setRecaptchaValue(value);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const form = e.currentTarget;
//     setValidated(true);

//     // Validación nativa de Bootstrap
//     if (form.checkValidity() === false) {
//       e.stopPropagation();
//       return;
//     }

//     if (!recaptchaValue) {
//       console.error('Please complete the reCAPTCHA.');
//       return;
//     }

//     const serviceId = 'service_dtrqxk5';
//     const templateId = 'template_zj1h2jp';
//     const userId = 'LpwagaB2zdxcjzRVW';

//     emailjs.send(serviceId, templateId, formData, userId)
//       .then(() => {
//         // Reset form y mostrar mensaje de éxito
//         setFormData({
//           first_name: '',
//           email_id: '',
//           message: '',
//         });
//         setRecaptchaValue(null);
//         recaptchaRef.current?.reset();
//         setValidated(false);

//         setSuccessMessage("Thanks for getting in touch! We'll get back to you soon.");

//         // Ocultar mensaje después de unos segundos (opcional)
//         setTimeout(() => setSuccessMessage(''), 6000);
//       })
//       .catch((error) => {
//         console.error('Error sending email:', error);
//       });
//   };

//   return (
//     <div className='contact' id="Contact">
//       <div className='ContactUs-container'>
//         <div className='contact-container'>
//           <h1 className='contact-title'>CONTACT US</h1>
//           <div className='contact-txt'>
//             <p>
//               Please don't hesitate to send us a message if you have any questions.
//               We are here to help and would be delighted to assist you with any inquiries you may have.
//             </p>
//           </div>

//           <div className="contactUs" id="contacto">
//             <div className='registerForm'>
//               <div className='formApply'>
//                 <Form noValidate validated={validated} onSubmit={handleSubmit} id='formApllyContact'>

//                   {/* Name */}
//                   <Form.Group className="mb-4" controlId="first_name">
//                     <Form.Label>Name:</Form.Label>
//                     <Form.Control
//                       required
//                       type="text"
//                       style={{ fontSize: '20px' }}
//                       name="first_name"
//                       value={formData.first_name}
//                       onChange={handleChange}
//                     />
//                     <Form.Control.Feedback type="invalid">
//                       Please enter your name.
//                     </Form.Control.Feedback>
//                     <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                   </Form.Group>

//                   {/* Email */}
//                   <Form.Group className="mb-4" controlId="email_id">
//                     <Form.Label>Email:</Form.Label>
//                     <InputGroup hasValidation>
//                       <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
//                       <Form.Control
//                         type="email"
//                         style={{ fontSize: '20px' }}
//                         aria-describedby="inputGroupPrepend"
//                         required
//                         name="email_id"
//                         value={formData.email_id}
//                         onChange={handleChange}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         Please provide a valid email address.
//                       </Form.Control.Feedback>
//                       <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                     </InputGroup>
//                   </Form.Group>

//                   {/* Message */}
//                   <Form.Group className="mb-4" controlId="message">
//                     <Form.Label>Message:</Form.Label>
//                     <InputGroup hasValidation>
//                       <Form.Control
//                         as="textarea"
//                         rows={3}
//                         style={{ fontSize: '20px' }}
//                         name="message"
//                         required
//                         value={formData.message}
//                         onChange={handleChange}
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         Please write a message.
//                       </Form.Control.Feedback>
//                       <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
//                     </InputGroup>
//                   </Form.Group>

//                   {/* reCAPTCHA */}
//                   <div className='d-flex justify-content-end mb-3'>
//                     <ReCAPTCHA
//                       ref={recaptchaRef}
//                       sitekey='6Le8WicpAAAAALhfy0WdYOliGf5E_8eKFEEDffSy'
//                       // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA'
//                       onChange={handleRecaptchaChange}
//                     />
//                   </div>

//                   {/* Submit Button */}
//                   <div className='btnForm d-flex justify-content-end'>
//                     <Button id="btnForm" type="submit">Send</Button>
//                   </div>
//                 </Form>

//                 {/* Mensaje de éxito */}
//                 {successMessage && (
//                   <div className="alert alert-success mt-4 text-center" role="alert">
//                     {successMessage}
//                   </div>
//                 )}

//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;


import React, { useState, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import emailjs from 'emailjs-com';
import ReCAPTCHA from "react-google-recaptcha";

export const Contact = () => {

  const [formData, setFormData] = useState({
    first_name: '',
    email_id: '',
    message: '',
  });

  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [validated, setValidated] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const recaptchaRef = useRef(null);

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prevFormData) => ({
    ...prevFormData,
    [name]: value,
  }));
};

const handleRecaptchaChange = (value) => {
  setRecaptchaValue(value);
};



  const handleSubmit = (e) => {
  e.preventDefault();

  if (isSubmitting) return;

  const form = e.currentTarget;
  setValidated(true);

  if (form.checkValidity() === false) {
    e.stopPropagation();
    return;
  }

  if (!recaptchaValue) {
    console.error('Please complete the reCAPTCHA.');
    return;
  }

  setIsSubmitting(true);

  const serviceId = 'service_dtrqxk5';
  const templateId = 'template_zj1h2jp';
  const userId = 'LpwagaB2zdxcjzRVW';

  emailjs
    .send(serviceId, templateId, formData, userId)
    .then(() => {

      setFormData({
        first_name: '',
        email_id: '',
        message: '',
      });

      setRecaptchaValue(null);
      recaptchaRef.current?.reset();

      setValidated(false);

      setSuccessMessage("Thanks for getting in touch! We'll get back to you soon.");

      setTimeout(() => {
        setSuccessMessage('');
      }, 6000);

    })
    .catch((error) => {
      console.error('Error sending email:', error);
    })
    .finally(() => {
      setIsSubmitting(false);
    });
};




  
  return (
    <div className='contact' id="Contact">
      <div className='ContactUs-container'>
        <div className='contact-container'>

          <h1 className='contact-title'>CONTACT US</h1>

          <div className='contact-txt'>
            <p>
              Please don't hesitate to send us a message if you have any questions.
              We are here to help and would be delighted to assist you with any inquiries you may have.
            </p>
          </div>

          <div className="contactUs" id="contacto">
            <div className='registerForm'>
              <div className='formApply'>

                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  id='formApllyContact'
                >

                  {/* Name */}
                  <Form.Group className="mb-4" controlId="first_name">
                    <Form.Label>Name:</Form.Label>

                    <Form.Control
                      required
                      type="text"
                      style={{ fontSize: '20px' }}
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                    />

                    <Form.Control.Feedback type="invalid">
                      Please enter your name.
                    </Form.Control.Feedback>

                    <Form.Control.Feedback>
                      Looks good!
                    </Form.Control.Feedback>
                  </Form.Group>

                  {/* Email */}
                  <Form.Group className="mb-4" controlId="email_id">
                    <Form.Label>Email:</Form.Label>

                    <InputGroup hasValidation>
                      <InputGroup.Text>@</InputGroup.Text>

                      <Form.Control
                        type="email"
                        style={{ fontSize: '20px' }}
                        required
                        name="email_id"
                        value={formData.email_id}
                        onChange={handleChange}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please provide a valid email address.
                      </Form.Control.Feedback>

                      <Form.Control.Feedback>
                        Looks good!
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  {/* Message */}
                  <Form.Group className="mb-4" controlId="message">
                    <Form.Label>Message:</Form.Label>

                    <InputGroup hasValidation>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        style={{ fontSize: '20px' }}
                        name="message"
                        required
                        value={formData.message}
                        onChange={handleChange}
                      />

                      <Form.Control.Feedback type="invalid">
                        Please write a message.
                      </Form.Control.Feedback>

                      <Form.Control.Feedback>
                        Looks good!
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  {/* reCAPTCHA */}
                  <div className='d-flex justify-content-end mb-3'>
                    <ReCAPTCHA
                      ref={recaptchaRef}
                      // sitekey='6Le0MU8oAAAAAM4zQ8AMbN6ylaqWJP8w-3MwrqMA'
                      sitekey='6Le8WicpAAAAALhfy0WdYOliGf5E_8eKFEEDffSy'
                      onChange={handleRecaptchaChange}
                    />
                  </div>

                  {/* SUCCESS MESSAGE (ARRIBA DEL BOTÓN) */}
                  {successMessage && (
                    <div className="alert alert-success text-center mb-3" role="alert">
                      {successMessage}
                    </div>
                  )}

                  {/* Submit Button */}
                  <div className='btnForm d-flex justify-content-end'>
                  <Button
                    id="btnForm"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Sending...' : 'Send'}
                  </Button>
                  </div>

                </Form>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;